import { Col, Row, Table } from "react-bootstrap";
import { FormCol, FormRow, Icon, LoadingSpinner, fas } from "../../../../component-library";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { Case, Claims } from "../../../../models";
import { usePermissions, useReferralDashboard } from "../../../../contexts";
import { CallBackSummary, ReferralHbovSummary, ReferralSummaryList } from ".";
import { Lists } from "../../../lists";
import { useCaseQuery } from "../../../../queries";

export function ReferralDashboardClassic() {
    const navigate = useNavigate();
    const { hasPermission } = usePermissions();
    const { createMutation } = useCaseQuery();
    const { isLoading, dashboardData, handleShowCallBackModal } = useReferralDashboard();

    const addReferralBtn = useMemo(() => {
        if (hasPermission(Claims.CreateCase)) {
            return (
                <Icon
                    icon={fas.faPlus}
                    onClick={() => createMutation.mutate()}
                    className="clickable"
                    title="New Referral"
                />
            );
        }
        return null;
    }, [createMutation, hasPermission]);

    if (isLoading || createMutation.isLoading) return <LoadingSpinner />;

    return (
        <FormRow>
            <FormCol xxl={7} xl={12} className="mb-2" cardTitle="Referrals" headerRightElement={addReferralBtn}>
                <Row className="referral-dashboard-card">
                    <Col lg={4} md={6} sm={12}>
                        <h3 className="text-center">New</h3>
                        <ReferralSummaryList
                            cases={dashboardData?.newReferrals ?? []}
                            onClick={(c: Case) => {
                                navigate(`/lists/${Lists.ReferralsNew}/cases/${c.id}/referral/${c.referral?.id}`);
                            }}
                        />
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                        <h3 className="text-center">Pending DFS/RN Updates</h3>
                        <ReferralSummaryList
                            cases={dashboardData?.referralsPendingDfsRnUpdates ?? []}
                            onClick={(c: Case) => {
                                navigate(
                                    `/lists/${Lists.ReferralsPendingDfsRn}/cases/${c.id}/referral/${c.referral?.id}`
                                );
                            }}
                        />
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                        <h3 className="text-center">Pending HBOV</h3>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped hover>
                                <tbody>
                                    {dashboardData?.referralsPendingHbov?.map((_case) => (
                                        <ReferralHbovSummary key={_case.id} case={_case} />
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </FormCol>
            <FormCol xxl={5} xl={12} className="mb-2" cardTitle="Call Backs">
                <Row className="referral-dashboard-card">
                    <Col>
                        <h3 className="text-center">Active</h3>
                        {dashboardData?.activeCallBacks.map((callBack) => (
                            <CallBackSummary
                                key={callBack.id}
                                callBack={callBack}
                                onClick={() => handleShowCallBackModal(callBack.id)}
                                isOnDashboard
                            />
                        ))}
                    </Col>
                    <Col>
                        <h3 className="text-center">Pending Follow-Up</h3>
                        {dashboardData?.qaCallBacks.map((callBack) => (
                            <CallBackSummary
                                key={callBack.id}
                                callBack={callBack}
                                onClick={() => handleShowCallBackModal(callBack.id)}
                                isOnDashboard
                            />
                        ))}
                    </Col>
                </Row>
            </FormCol>
        </FormRow>
    );
}
